import React, { useEffect, useMemo, useState } from 'react';
import axios from '../axiosConfig';
import { handleError, toastError, toastErrorUniqueInfinite, toastSuccess } from '../funciones.js';
import { FiltrosAdmin } from './FiltrosAdmin.js';
import CrearReunion from './CrearReunion.js';
import Imprimir from './Imprimir.js';
import { TablaN } from './TablaN.js';
import { useAxiosGet } from '../hooks/useAxiosGet.jsx';

export const MeetingsAdmin = (props) => {
    const [empresasRonda, setEmpresasRonda] = useState([]);
    const [mesasRonda, setMesasRonda] = useState([]);
    const [horariosRonda, setHorariosRonda] = useState([]);
    const [horaInicio, setHoraInicio] = useState("");
    const [empresaId, setEmpresaId] = useState("");
    const [numeroMesa, setNumeroMesa] = useState("");
    const [estadoReunion, setEstadoReunion] = useState("0");
    const [esParaEmpresas, setEsParaEmpresas] = useState(false);

    const [evento, setEvento] = useState({ nombre: '' });
    const itemsFiltro = [
        {
            setValue: setEmpresaId, value: empresaId, id: "empresaFiltroId", text: "Empresa",
            items: empresasRonda, idSeccion: 10, initialState: ""
        },
        {
            setValue: setEstadoReunion, value: estadoReunion, id: "estadoFiltro", text: "Estado",
            items: ["Concretadas", "Pendientes", "No concretadas"], mostrarTodas: true,
        },
        {
            setValue: setHoraInicio, value: horaInicio, id: "horarioFiltro", text: "Horario",
            items: horariosRonda, idSeccion: 10, isText: true, initialState: "", disabled: estadoReunion === "1"
        },
        {
            setValue: setNumeroMesa, value: numeroMesa, id: "mesaFiltro", text: "Mesa",
            items: mesasRonda, idSeccion: 10, isText: true, initialState: "", disabled: estadoReunion === "1"
        }
    ];
    const url = useMemo(() => {

        if (!props.evento?.id) return null;

        if (estadoReunion === "1") {
            return (
                "empresa/reunionesPendientes?eventoId=" +
                props.evento.id +
                (empresaId ? "&empresaId=" + empresaId : "")
            );
        }

        return (
            "empresa/empresasDeUnaReunion?eventoId=" +
            props.evento.id +
            (empresaId ? "&empresaId=" + empresaId : "") +
            (horaInicio ? "&horaInicio=" + horaInicio.split(" / ")[0] : "") +
            (numeroMesa ? "&numeroMesa=" + numeroMesa : "") +
            (estadoReunion === "2" ? "&creada=false" : "") +
            (estadoReunion === "0" ? "&creada=true" : "")
        );

    }, [
        props.evento?.id,
        estadoReunion,
        empresaId,
        horaInicio,
        numeroMesa
    ]);

    const { data, loading, refetch } = useAxiosGet(
        url,     // 1️⃣ url
        {},      // 2️⃣ params
        { enabled: !!props.evento?.id }
    );

    const [meetings, setMeetings] = useState([]);
    //const meetings = data || []
    useEffect(() => {
        if (estadoReunion === "1") {
            const elem = data.flatMap((group) =>
                group.empresasDeInteres.map((empresaInteres) => ({
                    empresa: group.empresa,
                    empresaInteres: empresaInteres,
                }))
            );
            setMeetings(elem || []);
        } else {
            setMeetings(data || []);
        }
    }, [data])


    useEffect(() => {
        if (props.evento !== undefined && props.evento !== null && props.evento.id !== undefined) {
            setEvento(props.evento)
            setEmpresaId('')
            setEstadoReunion('0')
            setHoraInicio('')
            setNumeroMesa('')
        }
        if (props.evento.id !== undefined) {
            const params = {
                params: {
                    eventoId: props.evento.id
                }
            }
            saveAxiosData(setEmpresasRonda, 'empresa/verEmpresasDeUnEvento', params)
            saveAxiosData(setHorariosRonda, 'evento/turnosDeUnEvento', params)
            saveAxiosData(setMesasRonda, 'evento/mesasDeUnEvento', params)
        }
    }, [props.evento])

    const saveAxiosData = (funcion, url, params) => {
        axios
            .get(process.env.REACT_APP_URL + url, params)
            .then(function (response) {
                funcion(response.data);
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
    }

    const [mostrarImprimir, setMostrarImprimir] = useState(false);

    const imprimir = (paraEmpresas) => {
        setEsParaEmpresas(paraEmpresas);
        setMostrarImprimir(true);

    };

    const handleImprimirReady = () => {
        setTimeout(() => {
            window.print();
            setMostrarImprimir(false);
        }, 100);
    };

    const contentMeeting = (elem) => {
        return (
            <>
                <div className={`col-sm-6 col-12 mb-3 mb-sm-0 nombreEventoMobile ${estadoReunion === "0" ? 'col-12-901-780 mb-3-901-780' : ''}`}>
                    {estadoReunion === "1" ?
                        elem.empresa?.nombre + " -> " + elem.empresaInteres?.nombre
                        : elem.empresas?.[0]?.nombre + " - " + elem.empresas?.[1]?.nombre
                    }
                </div>
                {estadoReunion === "0" ? (
                    <>
                        <div className='col-6 text-center col-sm-2 col-6-901-780'>
                            <span className='d-inline-block-mobile d-none me-2 d-inline-block-901-780'>Mesa:</span>{elem.mesa}
                        </div>
                        <div className='col-6 col-sm-3 text-center col-6-901-780'>
                            {elem.horaInicio + " / " + elem.horaFin}
                        </div>
                        <div className='text-end col-sm-3 col centrarMobile col-660 col-0-901-780'>
                        </div>
                    </>
                ) : (
                    <>
                        <div className='col text-center'>
                            {estadoReunion === "1" ? 'Pendiente' : 'No concretada'}
                        </div>
                    </>
                )}
            </>
        );
    };

    return (
        <>

            <CrearReunion evento={evento.id} cambiarReuniones={refetch} empresas={empresasRonda} horarios={horariosRonda} show={props.showedModals.includes('create')} />
            {mostrarImprimir && (<Imprimir eventoActual={evento} reuniones={meetings} esTodas={true} esParaEmpresas={esParaEmpresas}
                onReady={handleImprimirReady} />)}

            <FiltrosAdmin itemsFiltro={itemsFiltro} setShowedModals={props.setShowedModals} />

            <TablaN elementos={meetings} classNameTabla={'crearReunion'}
                itemsEncabezado=
                {estadoReunion === "0" ? [

                    {
                        className: 'col-6 d-none d-sm-block', text: <>
                            <div className='d-none-901-780'>Empresas</div>
                            <div className='d-inline-block-901-780 d-none'>Reuniones</div>
                        </>
                    },
                    { className: 'col-2 text-center d-none d-sm-block', text: <div className='d-none-901-780'>Mesa</div> },
                    { className: 'col-3 text-center d-none d-sm-block', text: <div className='d-none-901-780'>Horarios</div> },
                    {
                        className: 'col col-sm-1 text-center px-0', text: <div id="dropdownImprimirFixedAdmin" class="dropdown d-flex align-items-center" >
                            <div className='logoImprimir  logoImprimirEmpresasInscriptas d-inline-block mx-auto' alt="" data-bs-toggle="dropdown" aria-expanded="false" />

                            <ul class="dropdown-menu rounded-3">
                                <li>
                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado me-0 me-sm-3 mb-2 mb-sm-0 "
                                        onClick={() => imprimir(true)}>
                                        <div className='d-none d-md-block'>Imprimir para empresas</div>
                                        <div className='d-md-none'>Para empresas</div>
                                    </button>
                                    <button class="btn text-white colorPrincipal bold-botones btn-cuadrado"
                                        onClick={() => imprimir(false)}>
                                        <div className='d-none d-md-block'>Imprimir para administrador</div>
                                        <div className='d-md-none'>Para administrador</div>
                                    </button>
                                </li>

                            </ul>
                        </div >
                    }

                ] :
                    [{ className: 'col-6', text: 'Empresas' },]
                }
                itemsFilas={contentMeeting} elemNoEncontrado={'reuniones'}
                mostrarLoader={loading} />
        </>
    );
}